module.exports = {
  details: [
    {
      id: "details",
      name: "Detalhes",
      component: "PartyDetails",
      permission: 2,
      icon: "mdi-information",
    },
    {
      id: "policies",
      name: "Políticas",
      component: "PartyPolicies",
      permission: 2,
      icon: "mdi-security",
    },
    {
      id: "attractions",
      name: "Atrações",
      component: "PartyAttractions",
      permission: 2,
      icon: "mdi-music",
    },
    {
      id: "period",
      name: "Períodos",
      component: "PartyPeriod",
      permission: 2,
      icon: "mdi-calendar-blank-multiple",
      noFree: true,
    },
    {
      id: "faq",
      name: "FAQ",
      component: "PartyFaq",
      permission: 2,
      touchless: true,
      icon: "mdi-frequently-asked-questions",
    },
    {
      id: "map",
      name: "Mapa",
      touchless: true,
      component: "PartyMap",
      permission: 2,
      icon: "mdi-map",
    },
    {
      id: "co-author",
      name: "Co-autor",
      component: "PartyCoOrganizer",
      permission: 2 + 8,
      touchless: true,
      icon: "mdi-account-supervisor",
      noFree: true,
    },
    {
      id: "table-map",
      name: "Mapa de Assentos",
      component: "PartyTableMap",
      permission: 2,
      touchless: true,
      icon: "mdi-table-chair",
      noFree: true,
    },
    {
      id: "gallery",
      name: "Galeria",
      component: "PartyGallery",
      permission: 2,
      icon: "mdi-image",
    },

    // {
    //   id: "product",
    //   name: "Produtos",
    //   component: "PartyProductUpsell",
    //   permission: 2 + 16384,
    //   icon: "mdi-cube-send",
    // },
    {
      id: "printConfigurator",
      name: "Configuração de Impressão",
      component: "PartyPrintConfigurator",
      permission: 2,
      icon: "mdi-printer-settings",
      noFree: true,
    },
    {
      id: "rating",
      name: "Avaliações",
      component: "PartyRating",
      permission: 2,
      icon: "mdi-star",
      noFree: true,
    },
    {
      id: "banners",
      name: "Banners",
      component: "PartyBanners",
      permission: 2,
      icon: "mdi-image-multiple",
    },
    {
      id: "wa-group",
      name: "Grupos do Whatsapp",
      component: "PartyWhatsappGroup",
      permission: 2,
      icon: "mdi-whatsapp",
      noFree: true,
    },
    {
      id: "risk",
      name: "Risco",
      component: "PartyRiskOperations",
      permission: 4,
      icon: "mdi-alert",
      hideFromNavigation: true,
      noFree: true,
    },
  ],
  management: [
    {
      id: "tickets",
      name: "Ingressos",
      component: "PartyTicketsManagement",
      permission: 16,
      icon: "mdi-ticket",
      touchless: true,
      noFree: true,
    },
    {
      id: "offlinePayments",
      name: "Recebimentos Externos",
      component: "OfflinePaymentsManagement",
      permission: 8192,
      icon: "mdi-tray-arrow-down",
      noFree: true,
    },
    {
      id: "sellers",
      name: "PDV & Vendedores",
      component: "PartySeller",
      permission: [16],
      icon: "mdi-account-group",
      noFree: true,
    },
    {
      id: "ticketOffice",
      name: "Bilheteria",
      component: "PartyTicketOffice",
      permission: [16, 268435456],
      icon: "mdi-ticket-account",
      noFree: true,
    },
    {
      id: "refound",
      name: "Reembolsos",
      component: "TicketRefunds",
      permission: 128,
      icon: "mdi-cash-refund",
      noFree: true,
    },
    {
      id: "saleLinks",
      name: "Links de Venda",
      component: "SaleLinkManagement",
      permission: 2,
      icon: "mdi-qrcode",
      noFree: true,
    },
    {
      id: "coupon",
      name: "Cupons",
      component: "CouponManagement",
      permission: 65536,
      icon: "mdi-ticket-percent",
      noFree: true,
    },
    {
      id: "queue",
      name: "Fila",
      component: "PartyQueue",
      permission: 2,
      icon: "mdi-human-queue",
      noFree: true,
    },
    {
      id: "courtesy",
      name: "Cortesias",
      component: "CourtesyEmitter",
      permission: 524288,
      icon: "mdi-account-star",
      noFree: true,
    },
  ],
  reports: [
    {
      id: "reports",
      name: "Relatórios",
      component: "PartyReports",
      permission: 512,
      icon: "mdi-chart-bar",
      touchless: true,
      noFree: true,
    },
    {
      id: "resume",
      name: "Resumo",
      component: "PartyResumeReport",
      permission: 512,
      icon: "mdi-table-large",
      touchless: true,
      noFree: true,
    },
    {
      id: "guests",
      name: "Convidados",
      component: "PartyTickets",
      permission: 64,
      icon: "mdi-account-multiple",
      touchless: true,
      noFree: true,
    },
    {
      id: "analytics",
      name: "Analytics",
      component: "PartyLiveAnalytics",
      permission: 512,
      icon: "mdi-chart-line",
      touchless: true,
    },
    {
      id: "utm",
      name: "UTM",
      component: "PartyUTM",
      permission: 512,
      icon: "mdi-chart-tree",
      touchless: true,
      noFree: true,
    },
    {
      id: "financial",
      name: "Financeiro",
      component: "PartyFinancial",
      permission: [2048, 4096],
      icon: "mdi-cash-multiple",
      touchless: true,
      noFree: true,
    },
  ],
};
